import { preferenceLabels } from "variables";

export const removeEmptyKeys = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => {
      if (value === "" || value === null || value === undefined) return false;

      if (typeof value === "object" && !Array.isArray(value)) {
        return Object.keys(value).length > 0;
      }

      return true;
    })
  );

export const getSelectedOption = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  //  boolean format
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  //  single-select format
  if (typeof value === "string") {
    return value.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
  }

  //  object format
  if (typeof value === "object" && !Array.isArray(value)) {
    const selected = Object.entries(value).find(([, isSelected]) => isSelected === true);

    if (!selected) return "—";

    return selected[0].replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
  }

  return "—";
};

export const formatMissingLabel = (key) => {
  const label = preferenceLabels[key] || key;

  const smartHints = {
    arrival_time: "Not specified",
    parking_required: "Needs confirmation",
    has_pet: "Unknown",
    room_temperature_f: "Not set",
    sleep_preference: "Not selected",
  };

  return {
    label,
    hint: smartHints[key] || "Not provided",
  };
};
